export default "__VITE_ASSET__gDPO2whp__"